import React, { useState } from "react";
import ExistingStreams from "./kinesis/ExistingStreams";
import SetupNewStream from "./kinesis/SetupNewStream";
const StepKinesis = ({ hasStreams = false, ...restProps }) => {
  const [renderStreams, toggleRenderStreams] = useState(hasStreams);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderStreams ? /* @__PURE__ */ React.createElement(ExistingStreams, { ...restProps, toggleSetup: () => toggleRenderStreams(false) }) : /* @__PURE__ */ React.createElement(SetupNewStream, { ...restProps, toggleSetup: hasStreams ? () => toggleRenderStreams(true) : null }));
};
export default StepKinesis;
